const BaseColumn = require("components/columns/Column");
/*const formatNumber = require("app/util/formatNumber");
const formatInteger = require("app/util/formatNumber").integer;*/

class TextColumn extends BaseColumn {

    format(value) {
        if (typeof(this.props.formatter) === 'function') {
            return this.props.formatter(value);
        }
        switch (this.type) {
            case 'string':
                return value;
            case 'url':
                return <a href={this.data['url']} target={'_blank'}>{value}</a>;
           /* case 'integer':
                return formatInteger(value);
            case 'number':
                return formatNumber(value);*/
            default:
                return value;
        }
    }

    renderCellContent() {
        return (
            <React.Fragment>
                <label>{this.formatted_value}</label>
            </React.Fragment>
        )
    }

}

module.exports = TextColumn;
